import { DOT_LEFT, trackScale } from '../campaign';
import { Crop, GoldButton } from './Shared';
import { LockChipIcon, LockBtnIcon, BadgeCheckIcon, DoneCheckIcon } from './Icons';

/* One streak (Card / Vouchers / Gold / Referrals): tile icon, copy, the
   four-step gem track with its chest, and the CTA (prototype renderCard).
   - pre   : progress UI dimmed via CSS, lock chip, CTA "Unlocks on 18 Oct"
   - live  : CTA runs the streak's action; a completed streak shows the gold
             "Completed" badge and an outlined "Streak complete · Chest earned"
             CTA. Referrals keep their CTA (every friend is still +1 Gem) and
             note the extra Gems under the track instead.
   - ended : CTA disabled, "Completed" / "Campaign ended" */
export default function StreakCard({ streak, phase = 'live', progress = 0, completed = false, extraGems = 0, onCta }) {
  const s = streak;
  const step = Math.max(0, Math.min(progress, 4));
  const locked = phase === 'pre';
  const ended = phase === 'ended';
  const isRef = s.key === 'ref';
  const done = completed && !locked;
  const doneLook = done && !isRef; // referrals stay open after the chest

  let cta;
  if (locked) cta = <GoldButton disabled><LockBtnIcon /><span>Unlocks on 18 Oct</span></GoldButton>;
  else if (ended) cta = <GoldButton disabled>{done ? 'Completed' : 'Campaign ended'}</GoldButton>;
  else if (doneLook) cta = <GoldButton done><DoneCheckIcon /><span>Streak complete · Chest earned</span></GoldButton>;
  else cta = <GoldButton onClick={() => onCta && onCta(s.key)}>{s.cta}</GoldButton>;

  return (
    <div className={`gq-card${doneLook ? ' gq-done' : ''}`}>
      <div className="gq-tile"><img src={s.art} alt="" /></div>
      <div className="gq-t gq-ttl">{s.title}</div>
      <div className="gq-txt">
        <div className="gq-desc">{s.desc}</div>
        {s.fine && <div className="gq-fine">{s.fine}</div>}
      </div>
      {locked && (
        <div className="gq-lockchip"><LockChipIcon /><span>Unlocks 18 Oct</span></div>
      )}
      {done && (
        <div className="gq-badge gq-gold"><BadgeCheckIcon /><span>{isRef ? 'Chest earned' : 'Completed'}</span></div>
      )}
      <div className="gq-divider" />

      <div className="gq-track">
        <div className="gq-fill" style={{ transform: `scaleX(${trackScale(step)})` }} />
        <div className="gq-dot" style={{ transform: `translateX(${DOT_LEFT[step] - 2}px)` }} />
      </div>
      {[1, 2, 3, 4].map((k) => (
        <Crop key={k} kind="gem" className={`gq-gem gq-g${k}${k <= step ? ' gq-on' : ''}`} />
      ))}
      <div className="gq-chest">
        <Crop kind="chest" className="gq-cglow" />
        <Crop kind="chest" />
      </div>
      {s.labels.map((label, k) => (
        <div key={k} className={`gq-t gq-lab gq-l${k}`}>{label}</div>
      ))}
      {done && isRef && (
        <div className="gq-extra">
          <BadgeCheckIcon />
          <span>
            {extraGems > 0
              ? `Chest earned · +${extraGems} extra Gem${extraGems === 1 ? '' : 's'} from referrals`
              : 'Chest earned · every new friend is still +1 Gem'}
          </span>
        </div>
      )}

      {cta}
    </div>
  );
}
